
class SyncService {
  constructor() {
    this.syncInterval = null;
    this.isSyncing = false;
    this.onOnlineCallback = null;
  }

  start(onOnlineCallback) {
    this.onOnlineCallback = onOnlineCallback;

    // Initial sync if online
    if (navigator.onLine && this.onOnlineCallback) {
      this.onOnlineCallback();
    }

    // Periodic check
    this.syncInterval = setInterval(() => {
      if (navigator.onLine && !this.isSyncing && this.onOnlineCallback) {
        this.onOnlineCallback();
      }
    }, 5 * 60 * 1000);

    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  }

  handleOnline = () => {
    console.log('[SyncService] App came online');
    if (this.onOnlineCallback && !this.isSyncing) {
      this.onOnlineCallback();
    }
  };

  handleOffline = () => {
    console.log('[SyncService] App went offline');
  };

  stop() {
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
    }

    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
  }
}

export default new SyncService();